import type { Theme } from "./theme";

export type NavProps = {
  theme: Theme;
  rarionUrl: string;
};

export function Nav({ theme, rarionUrl }: NavProps) {
  return (
    <nav
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        padding: "20px clamp(20px, 5vw, 40px)",
        display: "flex",
        alignItems: "center",
        gap: 16,
      }}
    >
      <a
        href="/"
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          fontWeight: 600,
          fontSize: 17,
          letterSpacing: -0.3,
          color: theme.fg,
          textDecoration: "none",
        }}
      >
        Heimar
      </a>
      <div style={{ flex: 1 }} />
      <a
        href={rarionUrl}
        style={{
          fontSize: 14,
          color: theme.fg,
          textDecoration: "none",
        }}
      >
        Visit Rarion ↗
      </a>
    </nav>
  );
}
